"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconFeedback = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("./Icon");
// Material Icon
// https://material.io/resources/icons/?search=comment&icon=feedback&style=baseline
const IconFeedback = (props) => {
    return (react_1.default.createElement(Icon_1.SVGIcon, { ...props, size: props.size },
        react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
        react_1.default.createElement("path", { d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z" })));
};
exports.IconFeedback = IconFeedback;
